import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import CommonUtil from "../../util/CommonUtils";
import { sidebarContext } from "../../util/context";
import NavMenuControl from "./NavMenuControl";
import "./NavMenuControl.scss";

export default function HomeLayoutControl({ children }) {


  const [isUserAuthenticated, setUserAuthenticated] = useState(false);

  const navigate = useNavigate();
  useEffect(() => {
    if (CommonUtil.isEmptyString(localStorage.getItem("token"))) {
      if (!CommonUtil.isEmptyString(localStorage.getItem("isControlPanel"))) {
        navigate("/control-panel");
      }
      else {
        navigate("/");
      }
    } else {
      setUserAuthenticated(true);
    }
  }, []);

  return !isUserAuthenticated ? (
    <></>
  ) : (
    <sidebarContext.Provider>
      <Box
        style={{
          height: "100vh",
          width: "100vw",
          display: "flex",
        }}
      >
        <NavMenuControl />
        <div className="Maincontrol-body">
          <Outlet />
        </div>
      </Box>
    </sidebarContext.Provider>
  );
}
